function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="0 0 34 30" xmlns="http://www.w3.org/2000/svg" width="35" height="35" {...props}><path d="M33.802 8.849L32.553.359l-8.342 2.405c-.6.173-.946.801-.775 1.403.174.602.792.954 1.4.776l4.149-1.195-7.581 11.911-4.765-6.304-5.873 12.526-4.095-3.842-4.599 8.174V.508H.188v29.31h31.554v-1.891H3.702l3.522-6.258 4.263 4 5.606-11.953 4.467 5.912 9.374-14.726.629 4.28a1.133 1.133 0 0 0 1.285.958 1.136 1.136 0 0 0 .952-1.288" fill="currentColor" fillRule="nonzero" mask="url(#1)" /></svg>;
});